import type { EvidenceUploadMode, ModelResults } from 'api';

export const getAnalysisStatusUsingBaleModel = (
  model_results: ModelResults,
  _mode: EvidenceUploadMode
): 'rejected-material' | 'accepted' | 'warning' => {
  if (model_results.outputs?.[0]?.image_warning) {
    return 'warning';
  }

  return 'accepted';
};
